import { createFileRoute } from '@tanstack/react-router';
import { SemanticModelsCatalog } from '@/features/metric-hub/semantic-models/SemanticModelsCatalog';

export const Route = createFileRoute('/_authed/metric-hub/semantic-models/')({
  component: SemanticModelsCatalog,
});
